// src/components/MarketplaceMenu.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import { useSubscription } from '../context/SubscriptionContext';

const MarketplaceMenu = () => {
  const { hasRestriction } = useSubscription();

  // Only show menu item if user has marketplace integration feature
  if (!hasRestriction('marketplaceIntegration')) {
    return null;
  }

  return (
    <li className="nav-item">
      <Link to="/marketplace" className="nav-link">
        <span className="nav-icon">🏪</span>
        <span className="nav-text">Pazaryeri Entegrasyonu</span>
      </Link>
    </li>
  );
};

export default MarketplaceMenu;